// src/pages/Admin/AdminLoginPage.tsx
import { useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

interface TokenResponse {
    access_token: string;
    expires_in: number;
}

export default function AdminLoginPage() {
    console.log("AdminLoginPage rendered");

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async () => {
        setError("");

        console.log("handleLogin called");
        console.log("API_URL =", API_URL);
        console.log("Email =", email);

        try {
            const res = await axios.post<TokenResponse>(`${API_URL}/auth/token`, {
                email,
                password,
            });

            console.log("Login response:", res.data);

            const { access_token, expires_in } = res.data;

            // store token + expiry
            localStorage.setItem("token", access_token);
            localStorage.setItem(
                "token_expires_at",
                (Date.now() + expires_in * 1000).toString()
            );

            console.log("Token saved to localStorage");

            // navigate inside SPA (no full page reload)
            navigate("/admin/categories", { replace: true });
        } catch (err: any) {
            console.error("Login error:", err);
            setError("Invalid email or password.");
        }
    };

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "100%" }}
        >
            <Grid size={{ xs: 12, sm: 8, md: 4 }}>
                <Paper elevation={3} sx={{ p: 4 }}>
                    <Typography variant="h5" gutterBottom>
                        Admin Login
                    </Typography>

                    <Box sx={{ mt: 2 }}>
                        <TextField
                            fullWidth
                            label="Email"
                            type="email"
                            margin="normal"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />

                        <TextField
                            fullWidth
                            label="Password"
                            type="password"
                            margin="normal"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />

                        {error && (
                            <Typography color="error" sx={{ mt: 1 }}>
                                {error}
                            </Typography>
                        )}

                        <Button
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3 }}
                            onClick={handleLogin}
                        >
                            Login
                        </Button>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
}
